// extracted by css-extract-rspack-plugin
export default {"DependenciesPicker":"DependenciesPicker-module__DependenciesPicker__VkFh3At"};